import React, { useState } from "react";
import { StyleSheet, View, TextInput, Text, Platform } from "react-native";

import Clipboard from "@react-native-community/clipboard";

import Dialog from "../common/dialog";
import ManaButton from "../common/ManaButton";
import AppConfig from "../../../config/AppConfig";
import { isWeb } from "../../../helpers/utils";
import AppTheme from "../AppTheme";

export default function CopyAppleIdDialog({
  controller,
  onClose = () => {},
  onConfirm = () => {},
  version,
}) {
  const [textInput, setTextInput] = useState();
  const { currentUser, installId } = controller.state || {};

  const text = currentUser + " " + installId;

  const copyCodeToClipboard = () => {
    if (isWeb) {
      textInput.focus();
      document.execCommand("copy");
    } else {
      Clipboard.setString(installId);
    }

    onConfirm();
  };

  return (
    <View style={[styles.container]}>
      <Dialog.Container onClose={onClose} showCloseButton>
        <TextInput
          ref={(ref) => setTextInput(ref)}
          value={text}
          selectTextOnFocus={true}
          style={{ opacity: 0, height: 0 }}
        />

        <View style={styles.infos}>
          <Text style={styles.text}>Version {version}</Text>
          <Text style={styles.text}>{currentUser}</Text>
          <Text style={styles.text}>{installId}</Text>
        </View>

        <View style={styles.buttonContainer}>
          <ManaButton
            onPress={copyCodeToClipboard}
            style={styles.button}
            styleText={styles.buttonText}
            text="Copy ID"
          />
        </View>
      </Dialog.Container>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  },
  confirmText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 13,
    lineHeight: 16,
    letterSpacing: -0.078,
    color: "#2D3142",
  },
  infos: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#2D3142",
    marginBottom: 10,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 17,
    paddingBottom: 20,
  },
  button: {
    backgroundColor: AppTheme.DEFAULT_COLOR,
    width: 140,
    height: 40,
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    color: "#FFFFFF",
    lineHeight: 20,
    letterSpacing: 1,
  },
});
